import { Alert, Button, Card, Col, Form, Input, Layout, Row } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { authSelector } from "../../feature/auth/authSelector";
import { forgotPasswordRequest } from "../../feature/auth/authSlice";
import usePrevious from "../../hooks/usePrevious";

const { Header, Content } = Layout;

const ForgotPassword = () => {
  const [message, setMesssage] = useState("");
  const { errorMessage, isForgotPassword } = useSelector(({ authState }) =>
    authSelector(authState)
  );
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const prevIsForgotPassword = usePrevious(isForgotPassword);

  const onFormFinish = (values) => {
    const email = values.email.toLowerCase().replace(/\s/g, "");
    form.setFieldsValue({ email });
    dispatch(forgotPasswordRequest({ email }));
  };

  const onChange = () => {
    setMesssage(null);
  };

  useEffect(() => {
    if (prevIsForgotPassword && !isForgotPassword) {
      if (errorMessage) {
        setMesssage({ text: errorMessage.text, type: errorMessage.type });
      } else {
        setMesssage({
          text: (
            <div>
              Instructions for resetting your password have been sent to your
              email address.
            </div>
          ),
          type: "success",
        });
      }
    }
  }, [isForgotPassword]);

  return (
    <Layout className="layout-default layout-forgot-password">
      <Header className="flex-center">
        <div className="header-col header-brand">
          <h5>Asinzen Referral Portal</h5>
        </div>
      </Header>
      <Content>
        <Row className="box-send-email">
          <Col xs={12} lg={10}>
            <Card size="small" title={<h1>Forgot your password</h1>}>
              {message && <Alert message={message.text} type={message.type} />}
              <Form
                form={form}
                name="form"
                layout="vertical"
                onFinish={onFormFinish}
              >
                <Form.Item
                  name="email"
                  label="Email"
                  rules={[
                    { required: true, message: "Please input your email!" },
                    {
                      type: "email",
                      message: "The input is not valid email!",
                    },
                  ]}
                >
                  <Input onChange={onChange} />
                </Form.Item>
                <Form.Item>
                  <Button
                    style={{ width: "100%" }}
                    type="primary"
                    htmlType="submit"
                    loading={isForgotPassword}
                  >
                    Send email
                  </Button>
                </Form.Item>
              </Form>
            </Card>
          </Col>
        </Row>
      </Content>
    </Layout>
  );
};

export default ForgotPassword;
